import {
  Bell,
  Building2,
  RotateCcw,
  Save,
  ShieldCheck,
  SlidersHorizontal,
} from "lucide-react";
import {
  ModuleHeader,
} from "../../shared/components/ModuleHeader";
import {
  MaterialPreparationSettings,
} from "../production-requirements/MaterialPreparationSettings";
import { useSettingsWorkspace, type SettingsModuleProps } from "./useSettingsWorkspace";

export function SettingsModule(props: SettingsModuleProps) {
  const {
    notify,
    dataRefreshVersion,
    settings,
    setSettings,
    scoringProfile,
    setScoringProfile,
    saveSettings,
  } = useSettingsWorkspace(props);
  return (
    <>
      <ModuleHeader
        eyebrow="Sistem yapılandırması"
        title="Ayarlar"
        description="Satın alma kurallarını ve operasyon bildirimlerini yönetin."
        action={
          <button className="primary-button" onClick={saveSettings}>
            <Save size={16} /> Değişiklikleri kaydet
          </button>
        }
      />
      <div className="settings-grid">
        <MaterialPreparationSettings
          notify={notify}
          dataRefreshVersion={dataRefreshVersion}
        />
        <section className="settings-card">
          <div className="settings-title">
            <SlidersHorizontal size={18} />
            <div>
              <h2>Satın alma kuralları</h2>
              <p>Teklif ve onay eşiklerini belirleyin.</p>
            </div>
          </div>
          <label>
            Varsayılan para birimi
            <select
              value={settings.currency}
              onChange={(event) =>
                setSettings((current) => ({
                  ...current,
                  currency: event.target.value,
                }))
              }
            >
              <option>TRY</option>
              <option>EUR</option>
              <option>USD</option>
            </select>
          </label>
          <div className="weight-settings">
            <strong>
              Teklif karşılaştırma ağırlıkları · Sürüm {scoringProfile.version}
            </strong>
            {[
              ["amount", "Karşılaştırmaya esas tutar"],
              ["delivery", "Teslim süresi"],
              ["payment", "Ödeme vadesi"],
            ].map(([field, label]) => (
              <label key={field}>
                {label} (%)
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  value={
                    scoringProfile.weights[
                    field as keyof typeof scoringProfile.weights
                    ]
                  }
                  onChange={(event) =>
                    setScoringProfile((current) => ({
                      ...current,
                      weights: {
                        ...current.weights,
                        [field]: Number(event.target.value),
                      },
                    }))
                  }
                />
              </label>
            ))}
            <small>
              Toplam: %
              {Object.values(scoringProfile.weights).reduce(
                (sum, value) => sum + value,
                0,
              )}
            </small>
          </div>
        </section>
        <section className="settings-card">
          <div className="settings-title">
            <Bell size={18} />
            <div>
              <h2>Bildirimler</h2>
              <p>Operasyon uyarılarını yönetin.</p>
            </div>
          </div>
          <label className="toggle-row">
            <span>
              <strong>Termin yaklaşınca hatırlat</strong>
              <small>İhtiyaç tarihinden 2 gün önce</small>
            </span>
            <input
              type="checkbox"
              checked={settings.deadlineReminder}
              onChange={(event) =>
                setSettings((current) => ({
                  ...current,
                  deadlineReminder: event.target.checked,
                }))
              }
            />
          </label>
          <label className="toggle-row">
            <span>
              <strong>Düzeltme yanıtını hatırlat</strong>
              <small>24 saat yanıt alınmadığında</small>
            </span>
            <input
              type="checkbox"
              checked={settings.revisionReminder}
              onChange={(event) =>
                setSettings((current) => ({
                  ...current,
                  revisionReminder: event.target.checked,
                }))
              }
            />
          </label>
        </section>
        <section className="settings-card">
          <div className="settings-title">
            <Building2 size={18} />
            <div>
              <h2>Şirket bilgisi</h2>
              <p>Bu panel yalnızca ANL için yapılandırılmıştır.</p>
            </div>
          </div>
          <div className="company-lock">
            <img src="/anl-logo-new-2026.webp" alt="ANL" />
            <div>
              <strong>ANL</strong>
              <small>Tek şirket · Değiştirilemez</small>
            </div>
            <ShieldCheck size={18} />
          </div>
        </section>
      </div>
      <button
        className="reset-button"
        onClick={() => {
          setSettings({
            currency: "TRY",
            deadlineReminder: true,
            revisionReminder: true,
          });
          notify(
            "Varsayılan değerler forma uygulandı. Kalıcı olması için kaydedin.",
          );
        }}
      >
        <RotateCcw size={15} /> Varsayılan ayarlara dön
      </button>
    </>
  );
}
